/**
 * @file drag-n-drop.component.tsx
 * @description Form-control обертка для работы с UI DragNDropZone компонентом в react-hook-form
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, react-hook-form, @components/ui/layout/drag-n-drop-zone, @api/actions/file]
 * @related-files [@components/ui/layout/drag-n-drop-zone/drag-n-drop-zone.component.tsx, @api/actions/file.ts]
 */

import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { DragNDropZone as UIDragNDropZone } from '@components/ui/layout/drag-n-drop-zone';
import { FileService } from '@api/actions/file';
import { TAttachment } from '@src/types';
import { mergeUniqueValues } from '@utils/data-helper';

/**
 * Props для form-control компонента DragNDropZone с интеграцией react-hook-form
 */
interface IDragNDropZoneProps extends Omit<React.ComponentProps<typeof UIDragNDropZone>, 'value' | 'onChange'> {
    /** Control объект из react-hook-form для управления формой */
    control: Control;
    /** Имя поля в форме */
    name: string;
}

export const DragNDropZone: React.FC<IDragNDropZoneProps> = ({ control, name, ...props }) => {
    const uploadFile = async (file: File): Promise<TAttachment | undefined> => {
        const formData = new FormData();
        formData.append('file', file);

        

        return await FileService.create(formData);
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                const handleFilesUpload = async (files: File[]): Promise<void> => {
                    // Создаем массив промисов для загрузки файлов
                    const uploadPromises: Promise<TAttachment | undefined>[] = files.map((file: File) => uploadFile(file));
                    // После загрузки объединяем ранее сохраненные данные с новыми
                    const uploadedFiles = await Promise.all(uploadPromises);
                    field.onChange(
                        mergeUniqueValues(
                            field.value,
                            uploadedFiles.map((uploadedFile: TAttachment | undefined) => ({
                                ...uploadedFile,
                                type: { $type: 'EAttachmentType', id: '1', name: 'Файл' }
                            })),
                            'link'
                        )
                    );
                };

                return <UIDragNDropZone onChange={handleFilesUpload} {...props} />;
            }}
        />
    );
};
